/**
 * PageHead — page chrome: title row + optional count pill + subtitle + right slot.
 * Ported from lib/shell.jsx (claude_design project 5c0836b6-…).
 */

import React from 'react';

export interface PageHeadProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  /** Count shown as a pill next to the title */
  count?: number | string;
  /** Content rendered on the right side (e.g. action buttons) */
  right?: React.ReactNode;
}

export function PageHead({ title, subtitle, count, right }: PageHeadProps) {
  return (
    <div
      style={{
        padding: '16px 22px',
        borderBottom: '1px solid var(--border)',
        display: 'flex',
        alignItems: 'center',
        gap: 14,
        flexShrink: 0,
        background: 'var(--bg-canvas)',
      }}
    >
      <div className="grow">
        <div className="row gap-2">
          <h1 className="page-title" style={{ fontSize: 'var(--fs-xl)' }}>
            {title}
          </h1>
          {count != null && (
            <span
              style={{
                fontSize: 'var(--fs-sm)',
                fontWeight: 600,
                color: 'var(--text-muted)',
                background: 'var(--bg-muted)',
                borderRadius: 99,
                padding: '2px 9px',
              }}
            >
              {count}
            </span>
          )}
        </div>
        {subtitle && (
          <div
            className="text-muted"
            style={{ fontSize: 'var(--fs-sm)', marginTop: 2 }}
          >
            {subtitle}
          </div>
        )}
      </div>
      {right}
    </div>
  );
}

export default PageHead;
